import { createFileRoute } from '@tanstack/react-router';
import { PayoutTemplateForm } from '@/components/tenants/PayoutTemplateForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/payout-templates/new')({
  component: NewPayoutTemplateRoute,
});

function NewPayoutTemplateRoute() {
  const { tenantCode } = Route.useParams();

  return <PayoutTemplateForm tenantCode={tenantCode} />;
}
